import { render } from "./ModatechPage.vue?vue&type=template&id=d8efec36"
import script from "./ModatechPage.vue?vue&type=script&lang=js"
export * from "./ModatechPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__